import React from "react";
import { useSelector } from "react-redux";
import { Redirect, Route } from "react-router-dom";
import {
  hasCallHistoryAccess,
  hasCampaignsAccess,
  hasOnlyCallHistoryAccess,
} from "../../components/NewDevelopment/CommonComponents/Common";

const callHistoryAccessAllowedPaths = [
  "/account/call-history",
  "/account/agents",
  "/account/support-email",
];

const onlyCallHistoryAccessAllowedPaths = [
  "/account/call-history",
  "/account/support-email",
];

const campaignAccessAllowedPaths = [
  "/account/audiences",
  "/account/campaigns",
  "/account/call-settings",
];

const checkIsAccessible = (accountRoles: any, pathname: string) => {
  const hasCallAccess = hasCallHistoryAccess(accountRoles);
  const hasCampaignAccess = hasCampaignsAccess(accountRoles);
  const hasOnlyCallAccess =
    hasOnlyCallHistoryAccess(accountRoles) && !hasCampaignAccess;

  const allowedCallPaths = hasOnlyCallAccess
    ? onlyCallHistoryAccessAllowedPaths
    : callHistoryAccessAllowedPaths;

  const isCallRestricted =
    hasCallAccess && !allowedCallPaths.includes(pathname);

  const isCampaignRestricted =
    hasCampaignAccess &&
    !(
      [
        ...callHistoryAccessAllowedPaths,
        ...campaignAccessAllowedPaths,
      ].includes(pathname) ||
      pathname.includes("campaign-runs") ||
      pathname.includes("campaigns") ||
      pathname.includes("audiences") ||
      pathname.includes("call-settings")
    );

  return isCallRestricted || isCampaignRestricted;
};

const RestrictedAccountRoute = ({ children, ...rest }: any) => {
  const {
    AccountReducer: { accountRoles },
  } = useSelector((state: any) => state);

  return (
    <Route
      {...rest}
      render={({ location }) => {
        const isAccessible = checkIsAccessible(accountRoles, location.pathname);

        if (isAccessible) {
          return (
            <Redirect
              to={{
                pathname: "/account/call-history",
                state: { from: location },
              }}
            />
          );
        }
        return children;
      }}
    />
  );
};

export default RestrictedAccountRoute;
